import React from 'react'
import useStyles from './ReportsPage.styles'

type Props = {
  children: React.ReactNode
  'data-testid': string
}

function ReportsPage(props: Props) {
  const classes = useStyles()

  return (
    <div className={classes.root} data-testid={props['data-testid']}>
      {props.children}
    </div>
  )
}

export default ReportsPage
